import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import FormDialog from './form-dialog';


const styles = theme => ({
    root:{
        width:'100%',
        paddingTop:5,
        paddingBottom:15,
        alignItems:'flex-end',
        borderBottom:'rgba(224, 224, 224, 1) solid 1px'
    },
    titles:{
        width:200,
        fontSize:'110%',
    },
    textInput : {
        width:250,
        marginRight:50,
    },
    convText : {
        paddingBottom:7,
        paddingLeft:7,
        color:'#FF0000'
    },
    convText2 : {
        paddingBottom:7,
    },
    relations:{
        color:'rgba(64,186,208,1)',
        fontSize:'80%',
        display:'block'
    },
    notRelations:{
        color:'rgba(0,0,0,0.64)',
        fontSize:'80%',
        display:'block'
    },

});


class innerForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fixInputValue : props.row.fixValue,
            conversions:props.row.conversion,
            openConversions:false,
        }
    }

    handleClickConversion = () =>{
        this.setState({
            openConversions : true
        })
    };

    afterDialogCancelFunc = () =>{
        this.setState({
            openConversions : false
        })
    };

    /** event handler **/
    render () {
        const { classes,row} = this.props;
        const { conversions, openConversions} = this.state;

        const relation_text = (row.relation.length) ? <span className={classes.relations}>{row.relation.join(" + ")}</span> : <span className={classes.notRelations}>紐付け設定なし</span>;

        return ([
            <FormGroup className={classes.root} row key={"group"}>
                <Typography className={classes.titles}>
                    {row.label}
                    {relation_text}
                </Typography>
                <TextField
                    label="固定値"
                    placeholder="固定値"
                    className={classes.textInput}
                    value={!(row.fixValue) ? '(設定なし)' : row.fixValue}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                {conversions.length > 0 &&
                <Button variant="contained" color="primary" onClick={this.handleClickConversion} key={"button"}>
                    データ変換を確認
                </Button>
                }
                {conversions.length === 0 &&
                <Typography className={classes.convText2}>
                    (データ変換設定なし)
                </Typography>
                }
            </FormGroup>,
            <FormDialog
                open={openConversions}
                key={"dialog"}
                conversion={conversions}
                afterCancelFunc={this.afterDialogCancelFunc}
                afterOkFunc={this.afterDialogOkFunc}
            />
        ]);
    }
}
innerForm.propTypes = {
    row : PropTypes.object,
    dataIndex : PropTypes.number,
    afterChangeFunc : PropTypes.func
};
innerForm.defaultProps = {
    row : {}
};
export default withStyles(styles)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/mapping/step4/components/inner-form.js